<template>
  <div>
    <md-card class="search-area">
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>search</md-icon>검색 조건
        </h4>
      </md-card-header>
      <md-card-content>
        <table class="flex-table">
          <tr>
            <th>행사명</th>
            <td><input v-focus type="text" v-model="eventListQuery.eventTitle" v-on:keyup.enter="sendQuery"></td>
            <th>행사일시 (from)</th>
            <td>
              <div class="inline-flex">
                <input type="text" v-model="eventListQuery.fromUseDate" v-mask="'####-##-##'">
              </div>
            </td>
            <th>행사일시 (to)</th>
            <td>
              <div class="inline-flex">
                <input type="text" v-model="eventListQuery.toUseDate" v-mask="'####-##-##'">
              </div>
            </td>
          </tr>
        </table>
      </md-card-content>

      <md-card-actions md-alignment="right">
        <md-button class="md-info md-sm" @click="sendQuery"><md-icon>check</md-icon>검 색</md-button>
        <md-button class="md-success md-sm" @click="downloadExcel" v-exel-btn="[5,3]" :disabled="this.pagination.total === 0">
          <md-icon>get_app</md-icon>Excel 다운로드
        </md-button>
      </md-card-actions>
    </md-card>



    <!-- 목록 시작 -->
    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>assignment</md-icon>행사 내역
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.<span style="color: blue; font-weight: bold; padding-left: 20px;">* 회원수 클릭시 해당 회원 목록으로 이동</span></div>
          <div>
            <select v-model="pagination.perPage" name="pages" @change="perPageChange">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <grid ref="eventListGrid"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @click="onClickModalRow"
              @response="response"
        ></grid>

      </md-card-content>
      <slot name="bottomRightArea"></slot>
    </md-card>
  </div>
</template>
<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import Swal from "sweetalert2";
import moment from "moment";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import { Grid } from '@toast-ui/vue-grid';

export default {
  name: "eventListComp",
  props: {
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      joinerCntNm : "joinerCnt", // 참가자 수 컬럼명
      eventTitleNm : "eventTitle", // 행사명 컬럼명
      eventListQuery : {
        fromUseDate : null,
        toUseDate : null,
        eventTitle : ''
      },
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    };
  },
  methods: {
    sendQuery (){
      let option = {
        fromUseDate : this.customFormatter(this.eventListQuery.fromUseDate),
        toUseDate : this.customFormatter(this.eventListQuery.toUseDate),
        eventTitle : this.eventListQuery.eventTitle
      };
      this.$refs.eventListGrid.invoke("readData", 1, option);
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_EVENT_INFO_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.eventListGrid;
      this.gridProps['columns'] = [
          {header: '행사ID', name: 'eventId', align:"center", sortable: true},
          {header: '행사명', name: 'eventTitle', width:250, sortable: true,
            formatter(value) {
              return `<span style="color:#0091d5; cursor:pointer"">${value.value}</a>`;
            }
          },
          {header: '참가자수', name: 'joinerCnt', align: 'right', sortable: true,
            formatter(value) {
              return `<span style="color:#0091d5; cursor:pointer"">${value.value}</span>`;
            }
          },
          {header: '행사시작일', name: 'eventBegin', align:"center", sortable: true},
          {header: '행사장소', name: 'eventPlace', sortable: true},
          {header: '담당부서', name: 'eventPart', sortable: true},
          {header: '행사담당자', name: 'eventManager', sortable: true},
          {header: '연락처', name: 'eventTel', align:"center", sortable: true}
        ];
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.eventListGrid, event, this.pagination);
    },
    customFormatter(date) {
      let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
      return res;
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$emit('returnPagingResult', this.pagination);
      this.$emit('returnQueryResult', this.query);
    },
    /**
     * 그리드 클릭
     */
    onClickModalRow(item) {
      let _this = this;
      if(item.instance.getRow(item.rowKey) != null) {
        switch (item.columnName) {
          case (_this.joinerCntNm) :
            // 부모 컴포넌트 중 참가자 수 클릭 함수 전달
            this.$emit('returnResultCnt', item.instance.getRow(item.rowKey));
            break;
          case (_this.eventTitleNm) :
            // 부모 컴포넌트 중 행사명 클릭 함수 전달
            this.$emit('returnResultTitle', item.instance.getRow(item.rowKey));
            break;
        }
        kuaaFnc.scrollTo('scrollTargetBox');
      }
    },

    downloadExcel() {
      this.pagination.page = 1;
      this.pagination.perPage = this.pagination.total;
      this.pagination.fileName = '행사 관리';
      kuaaApi.requestFileDownload(
          URL_CONST.EVENT_INFO_EXCEL_DOWNLOAD,
          this.pagination,
          '행사 관리.xlsx',
          response => {
            this.pagination.page = this.pagination.page;
            this.pagination.perPage = this.pagination.perPage;
          }
      );
    },
  }
};
</script>

<style lang="css" scoped>
</style>